import { useParams } from "react-router-dom";
import useMainMenu from "../../api/useMainMenu";
import Header from "../Header/Header";
import Loader from "../Loader/Loader";
import ScreenSlider from "./ScreenSlider";

export default function ProductScreen({ type }) {
  const params = useParams();

  const { mainMenu, isLoading } = useMainMenu(type);

  const product = mainMenu?.find((item) => item.id === params.id);


  if (isLoading) {
    return (
      <>
        <Loader />
      </>
    );
  }
  if (!isLoading) {
    return (
      <div className="productScreen">
        <Header />
       <ScreenSlider product={product}/>
        <div className="container">
          <ul className="productScreen__description">
            <li className="productScreen__description--title">
              {product?.name}
            </li>
            <li className="productScreen__description--text">
              {product?.description ||
                "Гарний опис, який продасть цю страву!!!"}
            </li>
            <li className="productScreen__description--components">
              <span>Ціна: </span>
              {product?.sizePrices[0].price.currentPrice || 0} грн
            </li> 
          </ul>
        </div>
      </div>
    );
  }
}
